import { m } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Typography } from '@mui/material';
import { PropTypes } from 'prop-types';
//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';

DetailHeading.propTypes = {
  text: PropTypes.string,
  type: PropTypes.number,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0),
  backgroundColor: theme.palette.background.paper,
}));

export default function DetailHeading({ text, type }) {
  return (
    <RootStyle className="printable">
      <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
        <m.div>
          <Typography variant={`h${type}`}>{text}</Typography>
        </m.div>
      </Container>
    </RootStyle>
  );
}
